<template>
    <div class="flex-grow flex justify-center items-center relative mb-14">
        <div class="w-[40rem] flex flex-col items-center">
            <h2>Experience</h2>
            <div class="resume-entry">
                <span class="font-semibold">Since 2021</span>
                <span class="addition-wrapper sm:max-w-[20rem] md:text-left">
                  Actress / Voice Actress
                  <span class="addition">for clients such as:</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- Erste Bank</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- Strabag</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- Boehringer Ingelheim</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- Ella One</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- Escal Seafood</span>
                  <span class="addition company-item text-[16px] sm:text-[23px]">- etc.</span>
                </span>
            </div>
            <div class="resume-entry">
                <span class="font-semibold">Since 2017</span>
                <span class="sm:max-w-[20rem] md:text-left">Actress in various theatre productions</span>
            </div>
            <div class="resume-entry">
                <span class="font-semibold">2016-2019</span>
                <span class="addition-wrapper">
                  Acting training
                  <span class="addition">at the Elfriede Ott Acting Academy</span>
                  <span class="addition text-[16px] sm:text-[23px] -mt-3 sm:-mt-1">- completed with diploma</span>
                </span>
            </div>
        </div>
    </div>
    <footer class="footer text-lg">
        <a class="lg:text-left" href="mailto:gruber.mariaandrea@gmail.com">gruber.mariaandrea@gmail.com</a>
        <a class="lg:text-center" href="tel:+436604906867">+43 660 4906867</a>
        <a class="lg:text-right" href="https://www.instagram.com/mariaandreagruber/" target="_blank" rel="noopener">instagram.com/mariaandreagruber/</a>
        <span class="lighter lg:col-span-2 lg:text-left">Photos by Julia Aqua Art, Olesya Perfenyuk, Eckhard Waasmann</span>
        <a class="lighter lg:text-right" href="https://www.linkedin.com/in/tobias-gruber/" target="_blank" rel="noopener">Website by Tobias Gruber</a>
    </footer>
</template>

<script>
    export default {
        name: "Work",
    }
</script>

<style scoped lang="scss">
    h2, a, span {
        @apply text-white;
    }
    .resume-entry {
        @apply w-full text-2xl md:text-3xl flex justify-between mb-10 grid sm:grid-cols-2 grid-cols-1 sm:gap-x-10 md:gap-x-16;

        span {
            @apply text-center;
            &:first-of-type {
              @apply mb-2 md:mb-0 sm:text-right;
            }
            &:last-of-type {
              @apply sm:text-left;
            }
            &.addition-wrapper {
              @apply flex flex-col items-center sm:items-start;
              .addition {
                @apply opacity-90 text-gray-100 mt-1 transform scale-90 translate-x-2 sm:translate-x-0 sm:origin-left sm:text-left;
              }
              .addition.company-item {
                @apply mt-0 leading-tight;
              }
            }
        }
    }
    .footer {
        @apply w-full grid lg:grid-cols-3 gap-x-2 gap-y-3 lg:gap-y-6 text-center;

        .lighter {
          @apply text-sm opacity-80 text-gray-200;
        }
    }
</style>
